export default "/assets/images/problem-solved-10.48df69899c437b43.png";